export function getSalesTransactionGrowthChartData({
  transactions,
  selectedStoreCode,
  selectedMonthName,
  selectedYear,
}) {
  // 1) filter transactions
  const filtered = (transactions || [])
    .filter((tx) => tx.status === "C")
    .filter((sale) => {
      const date = new Date(sale.tran_date);
      const year = date.getFullYear();
      const month = date.toLocaleString("default", { month: "long" });
      const store = sale.store_code.replace("ANGELSPIZZA_", "");

      const okYear = selectedYear ? year === parseInt(selectedYear, 10) : true;
      const okMonth = selectedMonthName ? month === selectedMonthName : true;
      const okStore = selectedStoreCode ? store === selectedStoreCode : true;
      return okYear && okMonth && okStore;
    });

  // 2) group by monthYear
  const salesByMonth = {};
  const txCountByMonth = {};
  filtered.forEach((sale) => {
    const d = new Date(sale.tran_date);
    const year = d.getFullYear();
    const month = d.toLocaleString("default", { month: "long" });
    const key = `${month} ${year}`;

    salesByMonth[key] = salesByMonth[key] || [];
    txCountByMonth[key] = txCountByMonth[key] || 0;

    salesByMonth[key].push(sale);
    txCountByMonth[key]++;
  });

  // 3) calculate totals and counts
  const labels = Object.keys(salesByMonth);
  const growthSales = labels.map((key) => {
    return salesByMonth[key].reduce((sum, sale) => {
      // parse numeric fields
      const totalVal = parseFloat(sale.total) || 0;
      // use totalVal as gross sales
      return sum + totalVal;
    }, 0);
  });
  const txCounts = labels.map((key) => txCountByMonth[key]);

  // 4) return chart data
  return {
    labels,
    datasets: [
      {
        type: "line",
        label: "Growth Sales",
        data: growthSales,
        borderColor: "#ffd043",
        borderWidth: 2,
        fill: false,
        yAxisID: "y-axis-2",
      },
      {
        type: "bar",
        label: "Total Transactions",
        data: txCounts,
        backgroundColor: "#006096",
        yAxisID: "y-axis-1",
      },
    ],
  };
}

/**
 * Build Chart.js options for dual-axis Growth Sales vs Transactions chart.
 *
 * @returns {{ scales: object, plugins: object }}
 */
export function getSalesTransactionGrowthChartOptions() {
  return {
    scales: {
      "y-axis-1": {
        type: "linear",
        display: true,
        position: "left",
      },
      "y-axis-2": {
        type: "linear",
        display: true,
        position: "right",
        grid: { drawOnChartArea: false },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label || "";
            if (label) label += ": ";
            const y = context.parsed.y;
            if (y != null) {
              label += y.toLocaleString(undefined, {
                maximumFractionDigits: 2,
              });
            }
            return label;
          },
        },
      },
    },
  };
}
